import { useState, useEffect } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styles from './Questions.module.css';
import QuestionBank from './QuestionBank';

export default function Questions() {
  const [expanded, setExpanded] = useState(false);
  const [questionDict, setQuestionDict] = useState([]);

  useEffect(() => {
    const questionList = [];
    for (let i = 0; i < QuestionBank.length; i += 2) {
      const q = QuestionBank[i].split("Q:")[1];
      const a = QuestionBank[i + 1].split("A:")[1];
      questionList.push({ q, a });
    }
    setQuestionDict(questionList);
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={styles.Questions}>
      {
        questionDict.map((question, index) => (
          <Accordion key={index} expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel${index + 1}bh-content`}
              id={`panel${index + 1}bh-header`}
              className={styles.Accordion}
            >
              <Typography className={styles.AccordionHeader}>
                {question.q}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className={styles.AccordionItem}>
              <Typography className={styles.AccordionContent}>
                {question.a}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))
      }
    </div>
  );
}